/**
 * Medienprojekte Renderer
 * Renders the media projects grid
 */

import type { MedienprojekteData, StolpersteineData } from '../../types';
import { Carousel } from '../../components/carousel';

export function renderMedienprojekte(
  data: MedienprojekteData | null,
  stolpersteineData: StolpersteineData | null
): void {
  const container = document.getElementById('medienprojekte-grid');
  if (!container || !data) return;

  const stolpersteine = stolpersteineData?.stolpersteine ?? [];

  const html = data.projekte.map(projekt => {
    const stolperstein = stolpersteine.find(s => s.medienprojekt_ids?.includes(projekt.id));
    return `
    <article class="project-card splide__slide">
      <a href="medienprojekt/${projekt.slug}.html" class="project-card__image-wrapper">
        <img src="${projekt.vorschaubild}" alt="${projekt.titel}" class="project-card__image" loading="lazy">
      </a>
      <h4 class="project-card__title">
        <a href="medienprojekt/${projekt.slug}.html">${projekt.titel}</a>
      </h4>
      ${stolperstein ? `
        <p class="project-card__subtitle">
          Stolperstein ${stolperstein.nummer}<br>
          ${stolperstein.name}
        </p>
      ` : ''}
    </article>
  `;
  }).join('');

  container.innerHTML = html;

  // Initialize carousel if needed
  const carouselWrapper = container.closest('.splide');
  if (carouselWrapper) {
    new Carousel(carouselWrapper as HTMLElement);
  }
}
